import { Row, Col } from 'antd';
import { HOME } from '../../utils/routeUtils';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix } = ssCommonUtils;

export default class AfspTitle extends React.Component {
    constructor(props) { super(props); }

    getClasses() {
        const 
        { size } = this.props,
        defaultClasses = { container: '', title: '', subTitle: '' };
        switch(size) {
            case 'lg': return { 
                title: 'afsp-title-lg-title-div', 
                subTitle: 'afsp-title-lg-sub-title-div' 
            };

            case 'md': return { 
                title: 'afsp-title-md-title-div', 
                subTitle: 'afsp-title-md-sub-title-div' 
            };

            case 'sm': return { 
                title: 'afsp-title-sm-title-div', 
                subTitle: 'afsp-title-sm-sub-title-div' 
            };

            case 'xs': return { 
                title: 'afsp-title-xs-title-div', 
                subTitle: 'afsp-title-xs-sub-title-div' 
            };

            case 'na': return defaultClasses;
            default: return defaultClasses;
        }
    }

    render() {
        const { title, subTitle } = this.getClasses();
        return (
            <div>
                <div className={title}>
                    <a href={setEnvPrefix(HOME)}>
                        {'Flight Training Security Program (FTSP)'}
                    </a>
                </div>
                <div className={subTitle}>
                    <a href='http://www.dhs.gov' target='_blank'>
                        {'Department of Homeland Security'}
                    </a>
                </div>
            </div>
        );
    }
}
